import { render, staticRenderFns } from "./Rich_text_pro_v2.vue?vue&type=template&id=24dee84f"
import script from "./Rich_text_pro_v2.vue?vue&type=script&lang=js"
export * from "./Rich_text_pro_v2.vue?vue&type=script&lang=js"
import style0 from "./Rich_text_pro_v2.vue?vue&type=style&index=0&id=24dee84f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports